module.exports = __webpack_public_path__ + "media/src/images/icons/gray-arrow-back-03d52e1f8869f521cddf2694ea30bfe9.svg";